import { z } from 'zod';

const serviceAccountJsonSchema = z
  .string()
  .min(1, {
    message:
      'i18n.configuration.gcpServiceAccount.form.serviceAccountJson.errors.required',
  })
  .refine(
    value => {
      try {
        const parsed = JSON.parse(value);

        return (
          typeof parsed === 'object' &&
          parsed !== null &&
          'type' in parsed &&
          'project_id' in parsed &&
          'private_key' in parsed &&
          'client_email' in parsed
        );
      } catch {
        return false;
      }
    },
    {
      message:
        'i18n.configuration.gcpServiceAccount.form.serviceAccountJson.errors.invalid',
    },
  );

export const validationSchema = z.object({
  serviceAccountJson: serviceAccountJsonSchema,
  projectId: z.string().optional(),
});

// Separate schema for updates where serviceAccountJson is optional
export const updateValidationSchema = z.object({
  serviceAccountJson: z
    .union([serviceAccountJsonSchema, z.literal('')])
    .optional(),
  projectId: z.string().optional(),
});

export type FormValues = z.infer<typeof validationSchema>;

export const defaultValues: FormValues = {
  serviceAccountJson: '',
};
